<div *ngIf="noTableData">
  <div class="col-4 offset-4 marTB8 padTB16">
    <h5 class="H5Header marL16 center">
      <strong>No data available</strong>
    </h5>
  </div>
</div>
<div *ngIf="!noTableData">
  <mat-table class="onHover" [dataSource]="dataSource" id="matTabId">
    <ng-container *ngFor="let column of columnDefs; let i = index" [cdkColumnDef]="column">
      <mat-header-cell *cdkHeaderCellDef class="relative">
        <span
          class="GreyLight text_overflow shiftRight"
          [ngStyle]="{ display: i === 0 ? 'none' : '' }"
          [attr.name]="columnDefs[i]"
          >{{ headers[i] | titlecase }}</span
        >
      </mat-header-cell>
      <ng-container *ngIf="i === 0">
        <mat-cell *cdkCellDef="let element" [attr.name]="element[column]" class="GreyLight mainBodyTxt4">
          <span *ngIf="element[column].toLowerCase() !== 'pendingclarification'"> {{ element[column] }}</span>
          <span *ngIf="element[column].toLowerCase() === 'pendingclarification'">Pending Clarification </span>
        </mat-cell>
      </ng-container>
      <ng-container *ngIf="i !== 0">
        <mat-cell
          *cdkCellDef="let element; let j = index"
          (click)="
            column !== 'total' &&
            element.name !== 'total' &&
            element.name !== 'Processed' &&
            element.name !== 'Total' &&
            element.name !== 'Processed'
              ? showCandidates(j, column, element)
              : false
          "
          class="relative mainBodyTxt4"
        >
          <div class="shiftRight" [class.cell-color]="element.name === 'Processed' && column !== 'total'">
            <span
              *ngIf="!(j === selectedIndex && column === selectedColumn && enableChip)"
              [attr.name]="element[column].count"
            >
              {{ element[column].count }}</span
            >
          </div>
          <div
            class="chip shiftRight"
            (click)="removeChip(j, column, element)"
            [style.display]="!enableChip ? 'none' : ''"
            *ngIf="j === selectedIndex && column === selectedColumn && enableChip"
          >
            <div class="chip-content" [attr.name]="element[column].count">{{ element[column].count }}</div>
            <div class="chip-close">
              <svg class="chip-svg" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                ></path>
              </svg>
            </div>
          </div>
        </mat-cell>
      </ng-container>
    </ng-container>
    <tr>
      <mat-header-row *matHeaderRowDef="columnDefs"></mat-header-row>
    </tr>
    <tr>
      <mat-row *matRowDef="let row; columns: columnDefs" class="tableCSS"> </mat-row>
    </tr>
  </mat-table>
</div>
